import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface CreatorWebPresenceProps {
  formData: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export function CreatorWebPresence({ formData, handleInputChange }: CreatorWebPresenceProps) {
  return (
    <>
      <div className="space-y-4">
        <h3 className="text-lg font-medium">Web Links</h3>
        
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="shop">Shop URL</Label>
            <Input
              id="shop"
              name="shop"
              value={formData.shop || ""}
              onChange={handleInputChange}
              placeholder="https://..."
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="web_page">Website</Label>
            <Input
              id="web_page"
              name="web_page"
              value={formData.web_page || ""}
              onChange={handleInputChange}
              placeholder="https://..."
            />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="instagram_url">Instagram</Label>
            <Input
              id="instagram_url"
              name="instagram_url"
              value={formData.instagram_url || ""}
              onChange={handleInputChange}
              placeholder="https://instagram.com/..."
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="facebook_url">Facebook</Label>
            <Input
              id="facebook_url"
              name="facebook_url"
              value={formData.facebook_url || ""}
              onChange={handleInputChange}
              placeholder="https://facebook.com/..."
            />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="behance_url">Behance</Label>
            <Input
              id="behance_url"
              name="behance_url"
              value={formData.behance_url || ""}
              onChange={handleInputChange}
              placeholder="https://behance.net/..."
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="pinterest_url">Pinterest</Label>
            <Input
              id="pinterest_url"
              name="pinterest_url"
              value={formData.pinterest_url || ""}
              onChange={handleInputChange}
              placeholder="https://pinterest.com/..."
            />
          </div>
        </div>

        <div className="space-y-2">
          <Label htmlFor="bio">Bio</Label>
          <Textarea
            id="bio"
            name="bio"
            value={formData.bio || ""}
            onChange={handleInputChange}
            placeholder="Tell us about yourself..."
          />
        </div>
      </div>
    </>
  );
}